(function () {
  var checkInterval = setInterval(function () {
    var $banner = $('#bar721078_945228');
    var $header = $('header.site-header');

    if ($banner.length && $header.length) {
      clearInterval(checkInterval);
      console.log('✅ Elementos encontrados. Script activado.');

      $banner.css({
        transition: 'transform 0.3s ease, opacity 0.3s ease',
        'will-change': 'transform, opacity',
        'z-index': '9999'
      });

      $header.css({
        top: '0px',
        position: 'relative',
        'z-index': '9998',
        'margin-top': '46px',
        transition: 'top 0.2s ease, margin-top 0.2s ease'
      });

      var lastScrollY = $(window).scrollTop();

      $(window).on('scroll', function () {
        var currentScrollY = $(this).scrollTop();

        if (currentScrollY > lastScrollY) {
          $banner.css({ transform: 'translateY(-100%)', opacity: '0' });
          $header.css('margin-top', '0px');
        } else if (currentScrollY < lastScrollY) {
          $banner.css({ transform: 'translateY(0)', opacity: '1' });
          $header.css('margin-top', '46px');
        }

        lastScrollY = currentScrollY;
      });

      // Estado inicial
      if ($(window).scrollTop() > 0) {
        $banner.css({ transform: 'translateY(-100%)', opacity: '0' });
        $header.css('margin-top', '0px');
      } else {
        $banner.css({ transform: 'translateY(0)', opacity: '1' });
        $header.css('margin-top', '46px');
      }
    }
  }, 300);
})();
